import { __decorate, __metadata } from "tslib";
import { Event } from '@ftr/bus-messages';
import { Type } from '@ftr/serialization';
import { Timecode } from '../../../type/shared';
/**
 * The conversion of a recording's trm into playable audio has been finalized
 */
export class TrmConversionFinalized extends Event {
    /**
     * @param recordingTrm The TRM being converted
     * @param recordingConversionStatus Summary of the conversion statuses of the TRMs in this recording
     * @param trmConversionStatus The conversion status of the TRM after conversion has been finalized
     * @param convertedOutputs Details of the converted output generated by the TRM conversion. Undefined if the TRM is
     * inconvertible.
     * @param inconvertibleReason If the TRM was found inconvertible, the reason why the TRM is inconvertible. Undefined
     * if the conversion succeeded.
     * @param timecode Period of time during which the TRM was recorded
     * @param trmReconversionStatus The progress of a TRM's re-conversion
     * in a bulk reconversion process (see ReconvertRecordingsForCourtSystemTask).
     * @param conversionSource The initial reason this conversion was begun (i.e. batch reconversion, court upload, etc).
     */
    constructor(recordingTrm, recordingConversionStatus, trmConversionStatus, convertedOutputs, inconvertibleReason, timecode, trmReconversionStatus, conversionSource) {
        super();
        this.recordingTrm = recordingTrm;
        this.recordingConversionStatus = recordingConversionStatus;
        this.trmConversionStatus = trmConversionStatus;
        this.convertedOutputs = convertedOutputs;
        this.inconvertibleReason = inconvertibleReason;
        this.trmReconversionStatus = trmReconversionStatus;
        this.conversionSource = conversionSource;
        this.$name = TrmConversionFinalized.NAME;
        this.$version = 0;
        this.timecode = timecode;
    }
}
TrmConversionFinalized.NAME = 'ftr-recording/TrmConversionFinalized';
__decorate([
    Type(() => Timecode),
    __metadata("design:type", Object)
], TrmConversionFinalized.prototype, "timecode", void 0);
